module.exports = __webpack_public_path__ + "img/singvetor-min.f6f31e69.png";